import { Tooltip } from '@/design-system';
import { utcTime } from '@/utils/utc-time';

import { RunSchema } from '../types/schema';
import { LatencyChip } from './RunLatencyChip';

export function RunTimeToFirstToken(props: {
  run: RunSchema;
  percentiles?: {
    p50?: number;
    p99?: number;
  };
}) {
  if (!props.run.first_token_time) {
    return null;
  }

  const firstTokenMs =
    utcTime(props.run.first_token_time).diff(
      utcTime(props.run.start_time),
      'milliseconds'
    ) / 1000;
  return props.run?.first_token_time ? (
    <Tooltip
      title={
        <>
          Time to First Token is the time
          <br />
          it took to receive the first token
          <br />
          after the run started.
        </>
      }
    >
      <LatencyChip latency={firstTokenMs} percentiles={props.percentiles} />
    </Tooltip>
  ) : (
    <Tooltip title="This run did not stream output.">
      <span></span>
    </Tooltip>
  );
}
